import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";

/**
 * Surfaces the `?gcal=connected|error&reason=` result of the Google Calendar
 * OAuth callback, then strips the params. The callback returns the browser to
 * whichever page started the connect, so every such page mounts this.
 *
 * @param description Extra line on the success toast, for pages that have a
 * useful next step to point at.
 */
export function useGcalCallbackToast(description?: string) {
	const [searchParams, setSearchParams] = useSearchParams();

	useEffect(() => {
		const gcal = searchParams.get("gcal");
		if (!gcal) return;
		if (gcal === "connected") {
			toast.success("Google Calendar connected", { description });
		} else {
			const reason = searchParams.get("reason");
			toast.error("Google Calendar connection failed", {
				description: reason
					? `Reason: ${reason}. Please try again.`
					: "Please try again.",
			});
		}
		const newParams = new URLSearchParams(searchParams);
		newParams.delete("gcal");
		newParams.delete("reason");
		setSearchParams(newParams, { replace: true });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [searchParams]);
}
